module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isShow) ? _c('div', [_c('div', {
    staticClass: "dialog-wrap"
  }, [_c('div', {
    staticClass: "dialog-cover mark",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.closeMyself($event)
      }
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "drop"
    }
  }, [_c('div', {
    staticClass: "dialog-box"
  }, [_c('div', [_c('div', {
    staticClass: "dialogtype"
  }, [_c('div', {
    staticClass: "dialogtitle"
  }, [_vm._v("\n                " + _vm._s(_vm.title) + "\n                "), _c('span', {
    staticClass: "dialog-close",
    on: {
      "click": _vm.closeMyself
    }
  }, [_vm._v("×")])]), _vm._v(" "), _vm._t("default", [_vm._v("empty")])], 2)])])])], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-701a2398","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dialogs.vue
// module id = 265
// module chunks = 1